export default "__VITE_ASSET__C9ePs2xD__"